module.exports = __webpack_public_path__ + "img/li-ming.f6cb11d6.jpeg";